var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.getClass,style:(_vm.style)},[(_vm.badge)?_c('v-badge',{attrs:{"color":_vm.baggeColor,"inline":"","dot":"","value":_vm.badge}}):_vm._e(),_c('span',[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('span',[(_vm.model.link)?_c('a-view-action-link',{attrs:{"data":_vm.model.link,"values":_vm.values}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }